// @flow
import React, { useState, useRef } from 'react';
import {
  Modal, Select, Radio, Icon, Tooltip, Input,
} from 'antd';
import SimpleReactValidator from 'simple-react-validator';
import { SpH5, SpButton, SpError } from 'components/DesignKit';
import notify from 'components/NavIcons/notifiy';

type Props = {
  visible: boolean,
  close: Function,
  submit: Function,
  subscriptionDetails: Object,
};

const { Option } = Select;

const PauseSubscription = (props: Props) => {
  const {
    visible,
    close,
    submit,
    subscriptionDetails,
  } = props;

  const [, forceUpdate] = useState();
  const [pauseType, setPauseType] = useState(subscriptionDetails?.subscriptionChargeType || '');
  const [period, setPeriod] = useState('');
  const [frequency, setFrequency] = useState(subscriptionDetails?.plan2BillingFrequency || '');

  const simpleValidator = useRef(new SimpleReactValidator({
    validators: {
      frequency: {
        message: 'Billing period should not be more than 365 days',
        // eslint-disable-next-line radix
        rule: (val) => parseInt(val) <= 365,
      },
    },
  }));

  // eslint-disable-next-line consistent-return
  const deleteSelectedSubscription = (event) => {
    event.preventDefault();
    const formValid = simpleValidator.current.allValid();
    if (!formValid) {
      simpleValidator.current.showMessages();
      forceUpdate(1);
      return false;
    }
    const payload = {
      period,
      pauseType,
      subscriptionGid: subscriptionDetails?.gid,
    };
    submit(payload);
  };

  return (
    <Modal
      centered
      closable={false}
      visible={visible}
      title="Pause Subscription Details"
      footer={[
        <SpButton onClick={() => close()} type="secondary">Cancel</SpButton>,
        <SpButton onClick={deleteSelectedSubscription} type="primary">Pause Subscription</SpButton>,
      ]}
    >
      <div className="px-4">
        <div className="mb-3">
          <label htmlFor=""><SpH5>Billing Frequency</SpH5></label>
          <div className="d-flex align-items-center" style={{ width: '100%' }}>
            <span>Pause for the next</span>
            <div style={{ width: '15%', minWidth: '35px' }}>
              <Input
                className="ml-1"
                maxlength="3"
                value={period}
                onChange={(e) => {
                  const regex = /^[0-9\b]+$/;
                  const { value } = e.currentTarget;
                  if (regex.test(value) || value === '') {
                    setPeriod(e.currentTarget.value);
                  } else if (!regex.test(value)) {
                    setPeriod();
                  }
                }}
                onKeyPress={e => {
                  const keyCode = e.charCode || e.which;
                  if ((keyCode < 48 || keyCode > 57) && keyCode !== 46 && keyCode !== 44) {
                    e.preventDefault();
                  }
                }}
              />
            </div>
            <div>
              <Select
                className="ml-3"
                style={{ width: '135%' }}
                value={frequency}
                onChange={(e) => setFrequency(e)}
                disabled
              >
                <Option key={1} value="DAY">Day(s)</Option>
                <Option key={2} value="WEEK">Week(s)</Option>
                <Option key={3} value="MONTH">Month(s)</Option>
                <Option key={4} value="YEAR">Year(s)</Option>
              </Select>
            </div>
          </div>
          {
                      frequency === 'DAY' ? (
                        <SpError>
                          {simpleValidator.current.message('period', period, 'required|frequency')}
                        </SpError>
                      ) : (
                        <SpError>
                          {simpleValidator.current.message('period', period, 'required')}
                        </SpError>
                      )
                  }
        </div>
        <h6 className="mt-1 mb-2">When resume, What should happen</h6>
        <Radio.Group
          onChange={e => setPauseType(e.target.value)}
          value={pauseType}
        >
          {/* eslint-disable-next-line */}
          <Radio value="SKIP" className="ml-2">Skip&nbsp;&nbsp;&nbsp;
            {/* eslint-disable-next-line */}
            <Tooltip placement="right" title="When you resume your subscription in the middle of a billing cycle, you won’t charge the customer for that billing cycle">
              <Icon
                component={notify}
              />
            </Tooltip>
          </Radio><br />
          <Radio value="PRORATE" className="ml-2">Prorate&nbsp;&nbsp;&nbsp;
            {/* eslint-disable-next-line */}
            <Tooltip placement="right" title="When you resume your subscription in the middle of a billing cycle, you will charge the customer only for the remaining days in that cycle.">
              <Icon
                component={notify}
              />
            </Tooltip>
          </Radio><br />
          <Radio value="CHARGE" className="ml-2">Charge&nbsp;&nbsp;&nbsp;
            {/* eslint-disable-next-line */}
            <Tooltip placement="right" title="When you resume your subscription in the middle of a billing cycle, you will immediately charge the customer for that full cycle.">
              <Icon
                component={notify}
              />
            </Tooltip>
          </Radio>
        </Radio.Group>
        <div>
          <SpError>
            {simpleValidator.current.message('Pause type', pauseType, 'required')}
          </SpError>
        </div>
      </div>
    </Modal>
  );
};

// $FlowFixMe
export default PauseSubscription;
